import React from 'react';
import HoverTableRow from '../../commonComponents/util/HoverTableRow';

export default class ExternalParticipantsListRecord extends React.Component {

    render() {
        const {
            isBatched,
            isIsraeli,
            isOrgList,
            isReceivedRecord,
            showEditDelete,
            participant,
            participant: {
                externalListMemberId, addressDisplay,
                bankRoutingNumber, bankBranchNumber, bankAccountNumber, bankAccountHolder,
                displayName, orgEmployment, phoneNumber, secondPhoneNumber, teudatZahut, 
                isReceiving, isRemoved, numberOfTimesReceived
            }
        } = this.props;

        return (
            <HoverTableRow className={`table-row ${isRemoved ? 'deleted' : ''}`}>
                {isBatched && <td data-label="Select">
                    <div className="custom-check-container name-check-container">
                        <input type="checkbox" id={`select-${externalListMemberId}`} className="custom-check input"
                            disabled={isRemoved} // || savingSelection - for now not disabling while saving
                            checked={isReceiving}
                            onChange={e => this.props.select(externalListMemberId, e.target.checked)} />
                        <label htmlFor={`select-${externalListMemberId}`} className="secondary-text input" />
                    </div>
                </td>}
                <td data-label="Name">
                    <p className="bold-text">
                        {displayName}
                    </p>
                </td>
                {isReceivedRecord && <td data-label="ReceivedCount">
                    <p>{numberOfTimesReceived}</p>
                </td>}
                <td data-label="Phone">
                    <p>{[phoneNumber, secondPhoneNumber].filter(n => n).join(' | ')}</p>
                </td>
                <td data-label="Address">
                    <p>{addressDisplay}</p>
                </td>
                {isIsraeli && <td data-label="TeudatZahut">
                    <p>{teudatZahut}</p>
                </td>}
                {isIsraeli && <td data-label="BankNumber">
                    <p>{bankRoutingNumber}</p>
                </td>}
                {isIsraeli && <td data-label="BranchNumber">
                    <p>{bankBranchNumber}</p>
                </td>}
                {isIsraeli && <td data-label="AccountNumber">
                    <p>{bankAccountNumber}</p>
                </td>}
                {isIsraeli && <td data-label="AccountHolder">
                    <p>{bankAccountHolder}</p>
                </td>}
                {(!isIsraeli && isOrgList) && <td data-label="Position">
                    <p>{orgEmployment}</p>
                </td>}
                <td data-label="Edit">
                    <i className={`icon-pencil primary-hover ${isRemoved ? 'disabled' : ''}`}
                        onClick={() => {
                            if (!isRemoved) this.props.update(participant)
                        }}></i>
                </td>
                <td data-label="Delete" className="delete-table-cell">
                    <i className={isRemoved ? 'icon-refresh primary-hover' : 'icon-trash trash-hover'}
                        onClick={() => this.props.toggleRemoveRestore(participant)}></i>
                </td>
            </HoverTableRow>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/campaignComponents/externalLists/ExternalParticipantsListRecord.jsx